// extracted by mini-css-extract-plugin
export default {"category-row":"CategorySection_category-row__SUsKA","category_view":"CategorySection_category_view__NYylT","rightcol":"CategorySection_rightcol__kU1WZ"};